import type { BucketList } from '@planuze/admin-contracts';
import { Table, TableBody, TableCell, TableRow } from '@planuze/ui';

/* Visão bruta dos objetos no bucket R2 (auditoria) sobre o primitive `Table` de @planuze/ui
   (ADR-0118/0659). Só é renderizada quando há objetos (a page gateia por `length > 0`), então
   não tem empty state próprio; a coluna de tamanho é numérica (tabular-nums, alinhada à direita). */

interface Props {
  readonly objects: BucketList['objects'];
}

export function ReleaseBucketTable({ objects }: Props) {
  return (
    <Table>
      <TableBody>
        {objects.map((obj) => (
          <TableRow key={obj.key}>
            <TableCell className="font-mono text-xs">{obj.key}</TableCell>
            <TableCell numeric className="text-muted-foreground">
              {Math.round(obj.size / 1024)} KB
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
